export default __webpack_public_path__ + "static/media/terrific.10e708ed.mp3";